/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { socialGetSocialBilibiliReplies } from "../../funcs/socialGetSocialBilibiliReplies.js";
import { GetSocialBilibiliRepliesRequest$zodSchema } from "../../models/getsocialbilibilirepliesop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetSocialBilibiliRepliesRequest$zodSchema,
};

export const tool$socialGetSocialBilibiliReplies: ToolDefinition<typeof args> =
  {
    name: "social-get-social-bilibili-replies",
    description: `查询 B站评论

想要分析B站视频的评论区？这个接口可以帮你轻松获取评论数据，包括热门评论和最新评论，还支持分页加载。

## 功能概述
通过视频的 \`oid\`（通常就是视频的\`aid\`），你可以分页获取该视频的评论区内容。你可以指定排序方式和分页参数，来精确地获取你需要的数据。

## 参数说明
- **\`sort\` (排序方式)**
  - \`0\` 或 \`time\`：按时间排序
  - \`1\` 或 \`like\`：按点赞排序
  - \`2\` 或 \`reply\`：按回复数排序
  - \`3\` 或 \`hot\`（也支持 \`hottest\`、\`最热\`）：按最热排序

## 响应体字段说明
- **\`hots\` (热门评论)**: 仅在请求第一页时，可能会返回热门评论列表。其结构与 \`replies\` 中的对象一致。
- **\`replies\` (评论列表)**: 这是一个数组，包含了当前页的评论。其中：
  - \`root\`: 指向根评论的ID。如果评论本身就是根评论，则为 \`0\`。
  - \`parent\`: 指向该条回复所回复的上一级评论ID。如果评论是根评论，则为 \`0\`。`,
    scopes: ["read"],
    annotations: {
      "title": "",
      "destructiveHint": false,
      "idempotentHint": false,
      "openWorldHint": true,
      "readOnlyHint": true,
    },
    args,
    tool: async (client, args, ctx) => {
      const [result] = await socialGetSocialBilibiliReplies(
        client,
        args.request,
        { fetchOptions: { signal: ctx.signal } },
      ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      return formatResult(result.value);
    },
  };
